import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {featuresRoutes} from '@app/features/features.routing';
import {PageNotFoundComponent} from '@app/core/page-not-found/page-not-found.component';
import { OktaCallbackComponent } from '@okta/okta-angular';

const routes: Routes = [
    ...featuresRoutes,
    { path: '', redirectTo: 'health', pathMatch: 'full'},
    { path: 'implicit/callback', component: OktaCallbackComponent },
    { path: '**', component: PageNotFoundComponent, pathMatch: 'full' }
];

export const appRouting: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
});
